<template>
	<div>
		<div v-if="isPc == true" class="breadcrumb greyfont warp">
			<ul>
				<li>
					{{ title }}
				</li>
			</ul>
		</div>
		<div :class="isPc == true ? 'routerpage warp' : ''">
			<div :class="isPc == true ? 'tabar_bg' : 'tabar_bg-mob'">
				<p
					@click="tabarchange(index)"
					v-for="(item, index) in tabar_list"
					:key="index"
					:style="tabar_list_cur == index ? 'background:linear-gradient(to top, #005FB2, #2583D4);color: #fff;' : 'background: #00000000;color: #000'"
				>
					{{ item }}
				</p>
			</div>

			<HospitalGUI v-if="isPc == true"></HospitalGUI>

			<div :class="isPc == true ? 'doctorTeam' : 'doctorTeam-mob warp-mob'">
				<ul class="doctorTeam_list">
					<li @click="getpage(item.id)" v-for="(item, index) in doctorList" :key="index">
						<div class="doctorTeam_list_item_img">
							<img :src="item.coverimage" />
						</div>
						<div class="doctorTeam_list_item_text">
							<div>
								<p class="greyfont">所属科室：</p>
								<h1 class="officeh1">{{ item.department }}</h1>
							</div>
							<div>
								<p class="greyfont">医生姓名：</p>
								<h1>{{ item.fullname }}</h1>
							</div>
						</div>
					</li>
				</ul>

				<div v-if="isPc == true" class="pagecut">
					<el-pagination
						@current-change="handleCurrentChange"
						background
						:current-page="currentPage"
						layout="prev, pager, next"
						:total="data_length"
						:page-size="page_size"
					></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import HospitalGUI from '../components/HospitalGUI.vue';

export default {
	name: 'WebLijinhospitalDoctorTeam',
	components: {
		HospitalGUI
	},
	data() {
		return {
			isPc: true,
			pid: 0,
			title: '',
			tabar_list: [],
			tabar_list_cur: 0,
			doctorList: null,
			currentPage: 1,
			data_length: 0,
			page_size: 6
		};
	},

	mounted() {
		if ('id' in this.$route.query) {
			this.pid = this.$route.query['id'];
			this.title = this.$route.query['name'];
		} else {
			console.log('error');
		}
		if (document.body.clientWidth <= 820) {
			this.isPc = false;
			console.log(this.isPc);
		} else {
			this.isPc = true;
			console.log(this.isPc);
		}
		this.getdata(0);
	},

	methods: {
		handleCurrentChange(pageNumber) {
			this.currentPage = pageNumber;
			this.getdata(this.tabar_list_cur);
		},
		tabarchange(index) {
			this.currentPage = 1;
			this.tabar_list_cur = index;
			this.getdata(this.tabar_list_cur);
		},
		// 内容页
		getpage(e) {
			this.$router.push({
				path: '/content',
				query: { title: '医生团队', id: e }
			});
		},
		getdata(i) {
			let _t = this;
			this.$axios({
				url: 'http://www.ljxzxyy.cn/api/index/article',
				params: {
					pid: _t.pid
				}
			})
				.then((res) => {
					//请求成功
					console.log('article', res.data.data);
					let plist = res.data.data;
					let index_arr = [];
					for (var i1 = 0; i1 < plist.length; i1++) {
						_t.tabar_list[i1] = plist[i1]['nickname'];
						index_arr[i1] = plist[i1]['id'];
					}
					let category_id = index_arr[i];
					this.$axios({
						url: 'http://www.ljxzxyy.cn/api/index/article',
						params: {
							category_id: category_id,
							num: this.page_size,
							page: this.currentPage
						}
					})
						.then((res) => {
							//请求成功
							console.log('article', res.data);
							this.doctorList = res.data.data.list;
							this.data_length = res.data.data.count;
						})
						.catch((error) => {
							//请求失败
							console.log('article', error);
						});
				})
				.catch((error) => {
					//请求失败
					console.log('article', error);
				});
		}
	}
};
</script>

<style lang="scss" scoped></style>
